import { FiDownload } from "react-icons/fi";
import "../../styles/GlowButton.css";
import { AiOutlineDownload } from "react-icons/ai";

function GlowButton({ btnValue, btn1, onClick }) {
  return (
    <>
      {/* for btn value ===1 */}
      {btn1 === "1" &&
        <div className="flex glow-button">
          {/* Attach the onClick here */}
         <button
  onClick={onClick}
  className="group glow-button__button-white flex items-center gap-3"
>
            {btnValue}
          </button>
        </div>
      }

      {/* for btn value ===2 */}
      {btn1 === "2" &&
        <div className="flex glow-button glow-button--purple">
          {/* Attach the onClick here */}
          <button
            onClick={onClick}
            className="group glow-button__button-purple flex items-center gap-3 whitespace-nowrap"
          >
            {btnValue}
          </button>
        </div>
      }

      {/* for btn value ===3 */}
      {btn1 === "3" &&
        <div className="flex glow-button">
          {/* Attach the onClick here */}
          <button 
            onClick={onClick} 
            className="group glow-button__button-download flex items-center gap-3"
          >
            {btnValue}
            <div className="relative z-10 w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300 bg-[#6E3FC6]">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5 transition-all duration-300 stroke-white" fill="none" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <FiDownload style={{ marginRight: "0px", color: "white" }} size={24} />
              </svg>
            </div>
          </button>
        </div>
      }
    </>
  );
}

export default GlowButton;
